import * as React from "react"
import { Appearance, TextStyle, ImageStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Text } from "../text/text"
import { View } from "native-base"
import { AutoImage } from "../auto-image/auto-image"
import { Button } from "../button/button"
import Octicons from "react-native-vector-icons/Octicons"

const img = require("./auto-feeder-disabled.png")

const IMAGE: ImageStyle = {
  width: 40,
  height: 42,
  resizeMode: "contain",
}

const BTN_TEXT: TextStyle = {
  color: color.primary
}

export interface AutoFeederPondDisconnectedProps {
  /**
   * An optional style override useful for padding & margin.
   */
  colorScheme?: "light" | "dark",
  onFinishPushAll?: () => void,
  onConnect?: () => void
}

/**
 * Describe your component here
 */
export const AutoFeederPondDisconnected = observer(function AutoFeederPondDisconnected(props: AutoFeederPondDisconnectedProps) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    onConnect, ...restProps
  } = props

  return (
    <View position="absolute" right={0} bottom={0} left={0}>
      <View
        marginX="16px"
        marginBottom="16px"
        paddingLeft="6px"
        paddingRight="6px"
        paddingY="4px"
        borderRadius="8px"
        shadow={4}
        backgroundColor={color.palette.white}
        {...restProps}
      >
        <View flexDirection="row" alignItems="center" justifyContent="space-between">
          <View paddingRight="6px">
            <View
              position="absolute" zIndex="1" shadow={2} alignSelf="flex-end" marginTop="-4px" marginLeft="10px"
            >
              <Octicons name="x-circle-fill" size={14} color={color.palette.red400} />
            </View>
            <AutoImage source={img} style={IMAGE} />
          </View>
          <View flex={1} paddingX="8px" marginY="6px">
            <Text preset="title4" tx="autoFeederPondDetailScreen.disconnectedWarning" colorScheme={colorScheme} />
            <Text preset="body3" numberOfLines={1} tx="autoFeederPondDetailScreen.disconnectedWarningDescription" colorScheme={colorScheme} />
          </View>
          <Button
            testID="jala:id/push-button"
            tx="autoFeederPondCreateWizardScreen.connect"
            preset="link"
            textPreset="title3"
            textStyle={BTN_TEXT}
            onPress={onConnect}
          />
        </View>
      </View>
    </View>
  )
})
